import { Container } from "@components/ui/Container";
import { Button } from "@components/ui/Button";
import { ContactForm } from "../Contact/ContactForm";
import { company } from "@data/company";
import styles from "./QuickQuote.module.css";

const IconClock = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

const IconHandshake = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M11 17a2 2 0 1 0 4 0v-2" />
    <path d="m7 8 5-5 5 5" />
    <path d="M21 13v-3a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" />
    <path d="M3 13a2 2 0 1 0 4 0v-2" />
    <path d="M7 13a2 2 0 1 0 4 0v-2" />
  </svg>
);

const IconWhatsapp = () => (
  <svg viewBox="0 0 24 24" width={18} height={18} fill="currentColor" aria-hidden>
    <path d="M17.5 14.4c-.3-.2-1.8-.9-2.1-1s-.5-.2-.7.2c-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.5-.6.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1.1 1.1-1.1 2.7c0 1.6 1.1 3.1 1.3 3.3.2.2 2.3 3.5 5.5 4.9.8.3 1.4.5 1.8.7.8.2 1.5.2 2 .1.6-.1 1.8-.7 2-1.5.2-.7.2-1.4.2-1.5-.1-.1-.3-.2-.6-.4zm-5.4 7.4h-.1c-1.8 0-3.5-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4c-1-1.6-1.5-3.5-1.5-5.4 0-5.6 4.5-10 10-10 2.7 0 5.2 1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1.1 5.4-4.3 9.9-9.9 9.9zm8.5-18.5C18.6 1.2 15.4 0 12.1 0 5.5 0 .1 5.4.1 12c0 2.1.5 4.1 1.6 5.9L0 24l6.3-1.6c1.7.9 3.6 1.4 5.6 1.4h.1c6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.5z" />
  </svg>
);

export function QuickQuote() {
  return (
    <section id="cotizar" className={styles.section}>
      <Container>
        <div className={styles.grid}>
          <div className={styles.pitch}>
            <header className={styles.header}>
              <span className={styles.eyebrow}>
                <span className={styles.eyebrowDot} aria-hidden />
                Cotizá en minutos
              </span>
              <h2 className={styles.title}>
                Una <span className={styles.titleAccent}>cotización clara</span>,
                sin vueltas.
              </h2>
              <p className={styles.subtitle}>
                Comparamos opciones entre las principales aseguradoras del país
                y te volvemos con la propuesta que mejor se ajuste.
              </p>
            </header>

            <ul className={styles.trust}>
              <li className={styles.trustItem}>
                <span className={styles.trustIcon}>
                  <IconClock />
                </span>
                <span className={styles.trustLabel}>
                  <span className={styles.trustLabelTitle}>Menos de 24 hs</span>
                  <span className={styles.trustLabelHint}>Respuesta humana</span>
                </span>
              </li>
              <li className={styles.trustItem}>
                <span className={styles.trustIcon}>
                  <IconHandshake />
                </span>
                <span className={styles.trustLabel}>
                  <span className={styles.trustLabelTitle}>Sin compromiso</span>
                  <span className={styles.trustLabelHint}>Cotizar es gratis</span>
                </span>
              </li>
            </ul>

            <div className={styles.altCta}>
              <span className={styles.altCtaLabel}>¿Preferís chatear?</span>
              <Button
                as="a"
                href={`https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
                  "Hola, quiero una cotización",
                )}`}
                target="_blank"
                rel="noopener"
                variant="secondary"
              >
                <IconWhatsapp />
                Escribinos por WhatsApp
              </Button>
            </div>
          </div>

          <div className={styles.cardWrap}>
            <ContactForm compact />
          </div>
        </div>
      </Container>
    </section>
  );
}
